module.exports = __webpack_public_path__ + "static/media/01B.a1ca22c2.png";